import { Stepper, Step, StepLabel } from '@mui/material';

const CreateAccountStepsIndicator = ({
  steps,
  activeStep = 0,
  completedSteps = [],
}) => {
  return (
    <Stepper activeStep={activeStep} alternativeLabel sx={{ py: 2, px: 0 }}>
      {steps.map((step, index) => (
        <Step key={step.label} completed={completedSteps.includes(index)}>
          <StepLabel>{step.label}</StepLabel>
        </Step>
      ))}
    </Stepper>
  );
};

export default CreateAccountStepsIndicator;
